import { render, staticRenderFns } from "./ManageStars.vue?vue&type=template&id=d190fcb2&"
import script from "./ManageStars.vue?vue&type=script&lang=js&"
export * from "./ManageStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports